module.exports = __webpack_public_path__ + "resources/img/facetec-ui-customizations-10.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-ui-customizations-10.png
// module id = 1385
// module chunks = 0